<template>
  <!-- Без Transition намеренно, как у OfflineBanner: шторка может появиться и
       исчезнуть в одном тике (резервная ответила сразу после опроса), и
       перебитая анимация ухода оставляла бы элемент в DOM. Появление —
       CSS-анимацией, уход — мгновенный. -->
  <div v-if="notice" class="fixed left-0 right-0 bottom-0 z-[150] flex justify-center pointer-events-none">
    <div
      class="ai-sheet w-full max-w-[430px] bg-ink text-cream rounded-t-3xl px-5 pt-4 shadow-2xl"
      style="padding-bottom: max(18px, var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)))"
      role="status" aria-live="polite"
    >
      <div class="flex items-start gap-3">
        <svg class="shrink-0 mt-0.5" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M4 7h13l-3-3" />
          <path d="M20 17H7l3 3" />
        </svg>
        <div class="min-w-0">
          <p class="text-14 font-bold leading-snug">Основная модель перегружена</p>
          <p class="text-13 leading-snug" style="opacity: 0.85;">{{ body }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Шторка поверх экрана «Распознаю»: запрос ушёл к резервной модели.
// Состояние — utils/aiProgress.js (опрос POST /ai/progress).
import { computed } from 'vue'
import { aiFallbackNotice as notice } from '../utils/aiProgress.js'

const body = computed(() => notice.value?.reason === 'bypass'
  ? 'Распознаём резервной моделью — это может занять чуть дольше обычного.'
  : 'Переключили распознавание на резервную — ещё несколько секунд.')
</script>

<style scoped>
.ai-sheet { animation: ai-sheet-in 0.28s ease-out; }
@keyframes ai-sheet-in {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}
</style>
